<template>
  <button
    :class="[
      'button-status',
      classes,
      getStatusClass
    ]"
  >
    {{ statusName }}
  </button>
</template>

<script>
export default {
  name: "StatusButton",
  props: {
    classes: {
      type: String,
      default: ""
    },
    statusName: {
      type: String,
      required: true
    },
    statusId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      statuses: [
        {
          codes: ["N"],
          class: "button-status_1/4"
        },
        {
          codes: ["OP", "QP", "QA", "ND", "LN"],
          class: "button-status_2/4"
        },
        {
          codes: ["PQ"],
          class: "button-status_7/8 button-status_partially"
        },
        {
          codes: ["FQ", "AP"],
          class: "button-status_7/8 button-status_fully"
        },
        {
          codes: ["OD", "NC", "LP", "LT", "LL", "LC", "LI", "D"],
          class: "button-status_full button-status_lost"
        },
        {
          codes: ["F"],
          class: "button-status_full button-status_won"
        }
      ]
    };
  },
  computed: {
    getStatusClass() {
      if (!this.statusId) return "";

      const target_status = this.statuses.find(item =>
        item.codes.includes(this.statusId)
      );

      return target_status.class;
    }
  }
};
</script>

<style lang="scss" scoped>
.button-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 162px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--v-primary-base);
  background: #F5F5F5;
  border-radius: 5px;
  position: relative;
  z-index: 2;
  overflow: hidden;

  &_base {
    height: 36px;
  }

  &_md {
    height: 40px;
  }

  &::after {
    content: "";
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }

  &_1\/4 {
    &::after {
      width: 25%;
      background: #FEF2EF;
    }
  }

  &_2\/4 {
    &::after {
      width: 50%;
      background: #FCE4DE;
    }
  }

  &_7\/8 {
    color: #FFF;

    &::after {
      width: 87.5%;
    }
  }

  &_full {
    color: #fff;

    &::after {
      width: 100%;
    }
  }

  &_partially {
    &::after {
      background: #F2927C;
    }
  }

  &_fully {
    &::after {
      background: #EE765B;
    }
  }

  &_won {
    &::after {
      background: #EA5432;
    }
  }

  &_lost {
    &::after {
      background: #6C6D70;
    }
  }
}
</style>
